__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-scs-lib/v5_11_0/";